import { render, staticRenderFns } from "./Verificacion.vue?vue&type=template&id=c5aaaa70&scoped=true&"
import script from "./Verificacion.vue?vue&type=script&lang=js&"
export * from "./Verificacion.vue?vue&type=script&lang=js&"
import style0 from "./Verificacion.vue?vue&type=style&index=0&id=c5aaaa70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5aaaa70",
  null
  
)

export default component.exports